import React, { useEffect } from 'react';
import './Tabs.css';
import { Card } from '../card/Card';
import { MiniCard } from '../mini-card/MiniCard';
import { ProjectCard } from '../project-card/ProjectCard';

import html from '../../../assets/icons/html.png';
import css from '../../../assets/icons/css.png';
import javascript from '../../../assets/icons/javascript.png';
import sass from '../../../assets/icons/sass.png';
import bootstrap from '../../../assets/icons/bootstrap.png';
import tailwind from '../../../assets/icons/tailwind.png';
import php from '../../../assets/icons/php.png';
import sql from '../../../assets/icons/sql.png';
import csharp from '../../../assets/icons/csharp.png';
import reactjs from '../../../assets/icons/react.png';

import vscode from '../../../assets/icons/vscode.png';
import visualstudio from '../../../assets/icons/visual_studio.png';
import figma from '../../../assets/icons/figma.png';
import photoshop from '../../../assets/icons/photoshop.png';
import illustrator from '../../../assets/icons/illustrator.png';
import linux from '../../../assets/icons/linux.png';
import windows from '../../../assets/icons/windows.png';
import office from '../../../assets/icons/office.png';
import mysql from '../../../assets/icons/mysql.png';
import phpmyadmin from '../../../assets/icons/phpmyadmin.png';

import valeruki from '../../../assets/images/valeruki.jpg';
import unidadMedica from '../../../assets/images/unidad_medica.jpg';
import minotepad from '../../../assets/images/minotepad.png';
import blogger from '../../../assets/images/blogger.png';
import artwork from '../../../assets/images/artwork.png';


export const Tabs = () => {
    
    useEffect(() => {
        const tabItems = document.querySelectorAll('.tabs__header__item');
        const tabBodies = document.querySelectorAll('.tabs__body');
        tabItems.forEach(function (item, index){
            item.addEventListener('click', () => {
                for (let i = 0; i < tabItems.length; i++){
                    tabItems[i].classList.remove('active')
                    tabBodies[i].classList.remove('show')
                }
                item.classList.add('active')
                tabBodies[index].classList.add('show')
            });
        });
    },[]);    

    return (
        <div className='tabs'>
            <div className='tabs__header'>
                <div className="tabs__header__item active">
                    <h3>KNOWLEDGE</h3>
                </div>
                <div className="tabs__header__item">
                    <h3>EXPERIENCE</h3>
                </div>
                <div className="tabs__header__item">
                    <h3>EDUCATION</h3>
                </div>
                <div className="tabs__header__item">
                    <h3>PROJECTS</h3>
                </div>
            </div>
            <div className='tabs__body show'>
                <Card title="TECHNOLOGIES">
                    <MiniCard image={html} name="HTML5" alt="HTML5"/>
                    <MiniCard image={css} name="CSS3" alt="CSS3"/>
                    <MiniCard image={javascript} name="Javascript" alt="Javascript"/>
                    <MiniCard image={sass} name="Sass" alt="Sass"/>
                    <MiniCard image={bootstrap} name="Bootstrap" alt="Bootstrap"/>
                    <MiniCard image={tailwind} name="Tailwind" alt="Tailwind"/>
                    <MiniCard image={php} name="PHP" alt="PHP"/>
                    <MiniCard image={sql} name="SQL" alt="SQL"/>
                    <MiniCard image={csharp} name="C#" alt="C#"/>
                    <MiniCard image={reactjs} name="React.js" alt="React.js"/>    
                </Card>

                <Card title="SOFTWARE">
                    <MiniCard image={vscode} name="VS Code" alt="VS Code"/>
                    <MiniCard image={visualstudio} name="Visual Studio" alt="Visual Studio"/>
                    <MiniCard image={figma} name="Figma" alt="Figma"/>
                    <MiniCard image={photoshop} name="Photoshop" alt="Photoshop"/>
                    <MiniCard image={illustrator} name="Illustrator" alt="Illustrator"/>
                    <MiniCard image={linux} name="Linux" alt="Linux"/>
                    <MiniCard image={windows} name="Windows" alt="Windows"/>
                    <MiniCard image={office} name="MS Office" alt="MS Office"/>
                    <MiniCard image={mysql} name="My SQL" alt="My SQL"/>
                    <MiniCard image={phpmyadmin} name="PHPMyAdmin" alt="PHPMyAdmin"/>
                </Card>
            </div>
            <div className='tabs__body'>
                <Card title="FRONTEND DEVELOPER">
                    <p className='text-info-high'>Self-employed</p>
                    <p className='text-info'>Website development using HTML, CSS, SASS, Javascript and PHP technologies.</p>
                    <p className='text-info-low'>From 2017 to present</p>
                </Card>
                <Card title="COLORPIXEL FRONTEND DEVELOPER">
                    <p className='text-info-high'>Contract role</p>
                    <p className='text-info'>Website development using HTML, CSS, SASS, Javascript and PHP technologies with ColorPixel</p>
                    <p className='text-info-low'>From 2021 to 2022</p>
                </Card>
                <Card title="Technical support, auditor and guarantee coordinator">
                    <p className='text-info-high'>Digitex Internacional</p>
                    <p className='text-info'>SAMSUNG Campaign: Give technical support to SAMSUNG customers. Create online help material on the SAMSUNG website. Audit phone and chat technical support staff. Coordinate the people in charge of the guarantees and services of SAMSUNG.</p>
                    <p className='text-info-low'>From 2013 to 2016</p>
                </Card>
                <Card title="System manager">
                    <p className='text-info-high'>Al Volante (driving school)</p>
                    <p className='text-info'>Settings and maintenance of computer equipment. Registration and processing of all company information. Technical support to other offices of the company.</p>
                    <p className='text-info-low'>From 2008 to 2013</p>
                </Card>
                <Card title="TEACHER">
                    <p className='text-info-high'>POLITÉCNICO INDES (Technical school)</p>
                    <p className='text-info'>Training to students in basic computing, databases and introduction to algorithms.</p>
                    <p className='text-info-low'>From 2008 to 2009</p>
                </Card>
            </div>
            <div className='tabs__body'>
                <Card title="University / Professional Degree">
                    <p className='text-info-high'>Business administrator</p>
                    <p className='text-info'>UNIVERSIDAD DE SUCRE</p>
                    <p className='text-info-low'>From 2007 to 2013</p>
                </Card>
                <Card title="Technical degree">
                    <p className='text-info-high'>Software developer</p>
                    <p className='text-info'>POLITÉCNICO INDES</p>
                    <p className='text-info-low'>From 2003 to 2005</p>
                </Card>
                <Card title="languages">                    
                    <p className='text-info-high'>Spanish</p>                    
                    <p className='text-info-low'>Level: Native</p>
                    <p className='text-info-high'>English</p>                    
                    <p className='text-info-low'>Level: Intermediate (B1)</p>
                </Card>
            </div>
            <div className='tabs__body'>
                <Card title="diego's artwork">
                    <ProjectCard 
                        image={artwork} 
                        alt="Diego´s Artwork"
                        title="Diego's Artwork"
                        description="Web gallery to show my digital artwork."
                        link="https://daedsoft.github.io/my-artwork/"
                        linkName="my-artwork.github"
                    />
                </Card>
                <Card title="valeruki">
                    <ProjectCard 
                        image={valeruki} 
                        alt="valeruki.com.co"
                        title="VALERUKI Web Site"
                        description="Fullstack project  build with: HTML, CSS, SASS, Bootstrap, Javascript and PHP (Api Rest)."
                        link="https://valeruki.com.co"
                        linkName="valeruki.com.co"
                    />
                </Card>
                <Card title="unidad médica visual">
                    <ProjectCard 
                        image={unidadMedica} 
                        alt="Unidad Médica Visual"
                        title="Unidad Médica Visual Web Site"
                        description="Fullstack project  build with: HTML, CSS, SASS, Bootstrap Grid, Javascript and PHP."
                        link="https://daedsoft.github.io/unidad_medica/index.html"
                        linkName="unidadmedicavisual.github"
                    />
                </Card>
                <Card title="Mi NotePad 1.0">
                    <ProjectCard 
                        image={minotepad} 
                        alt="Mi NotePad 1.0"
                        title="Windows Desktop App: Mi NotePad 1.0"
                        description="Desktop app build with WindowsForm framework in Visual Studio. Programming language: C# - POO "
                        link="https://daedcoder.blogspot.com/2020/07/creacion-del-editor-de-texto-mi-note.html"
                        linkName="blogspot.minotepad"
                    />
                </Card>
                <Card title="DAED CODER BLOG">
                    <ProjectCard 
                        image={blogger} 
                        alt="daedcoder.blogspot.com"
                        title="DAED CODER BLOG"
                        description="Blog build in Blogger about programming (mostly in C#)"
                        link="https://daedcoder.blogspot.com"
                        linkName="daedcoder.blogspot.com"
                    />
                </Card>
            </div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/content-container/tabs/Tabs.jsx